import { render, staticRenderFns } from "./LabourerInfoSearchPage.vue?vue&type=template&id=17ddaa9c&scoped=true&"
import script from "./LabourerInfoSearchPage.vue?vue&type=script&lang=js&"
export * from "./LabourerInfoSearchPage.vue?vue&type=script&lang=js&"
import style0 from "./LabourerInfoSearchPage.vue?vue&type=style&index=0&id=17ddaa9c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17ddaa9c",
  null
  
)

export default component.exports